import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthLayout, Field } from "@/components/AuthLayout";

export default function Register() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "", confirm: "", agree: false });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 8) return toast.error("Parol minimum 8 simvol olmalıdır");
    if (f.password !== f.confirm) return toast.error("Parollar uyğun gəlmir");
    if (!f.agree) return toast.error("18 yaşdan yuxarı olduğunuzu təsdiq edin");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { email: f.email, password: f.password });
      login(data.token, data.user);
      toast.success("Qeydiyyat uğurla tamamlandı!");
      nav("/");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Qeydiyyat" subtitle="Bir dəqiqədə hesab yaradın">
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <Field label="Email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="email@nümunə.az" data-testid="register-email-input" />
        <Field label="Parol (min. 8 simvol)" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="••••••••" data-testid="register-password-input" />
        <Field label="Parolu təkrarlayın" type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} placeholder="••••••••" data-testid="register-confirm-input" />
        <label className="flex items-center gap-3 text-sm text-zinc-400 cursor-pointer">
          <input type="checkbox" checked={f.agree} onChange={(e) => setF({ ...f, agree: e.target.checked })} className="accent-[#D4AF37] w-4 h-4" data-testid="register-age-checkbox" />
          18 yaşdan yuxarı olduğumu və qaydaları qəbul etdiyimi təsdiq edirəm
        </label>
        <button disabled={loading} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="register-submit-btn">{loading ? "Gözləyin..." : "Hesab yarat"}</button>
        <p className="text-center text-sm text-zinc-400">Artıq hesabınız var? <Link to="/login" className="text-[#D4AF37]" data-testid="go-login-link">Giriş</Link></p>
      </form>
    </AuthLayout>
  );
}
